<template>
  <div class="apartment-img-main" @click.capture="apartmentPopUpVisible = true">
    <el-image
      class="card-img-main"
      :src="item.images[0].path"
      :fit="firstImgFit"
      lazy
    ></el-image>
    <el-image
      v-if="item.images.length > 1"
      class="card-img-second"
      :src="item.images[1].path"
      :fit="secondImgFit"
      lazy
    ></el-image>

    <button class="fast-forward-wrapper" type="button">
      <IconBase height="16" width="16">
        <Eye />
      </IconBase>
      <span>Швидкий перегляд</span>
    </button>
    <!--  Dialog   -->
    <el-dialog :visible.sync="apartmentPopUpVisible" width="1110px">
      <ApartmentPopUp :item="item" :DetailDescription="DetailDescription" />
    </el-dialog>
    <!-- dialog end -->
  </div>
</template>

<script>
import ApartmentPopUp from '@/components/common/PopUps/ApartmentPopUp'
import IconBase from '@/components/icons/IconBase'
import Eye from '@/components/icons/Eye'
export default {
  name: 'ApartmentImage',
  components: {
    ApartmentPopUp,
    IconBase,
    Eye,
  },
  props: {
    DetailDescription: Boolean,
    item: Object,
  },
  created() {
    this.setImagesFit()
  },
  data() {
    return {
      apartmentPopUpVisible: false,
      firstImgFit: 'fill',
      secondImgFit: 'fill',
    }
  },
  methods: {
    setImagesFit() {
      const vm = this
      const firstImg = new Image()
      const secondImg = new Image()
      firstImg.src = this.item.images[0].path
      firstImg.onload = function () {
        this.width > this.height
          ? (vm.firstImgFit = 'fill')
          : (vm.firstImgFit = 'contain')
      }
      if (this.item.images.length > 1) {
        secondImg.src = this.item.images[1].path
        secondImg.onload = function () {
          this.width > this.height
            ? (vm.secondImgFit = 'fill')
            : (vm.secondImgFit = 'contain')
        }
      }
    },
  },
}
</script>

<style lang="scss">
.apartment-img-main {
  display: block;
  width: 425px;
  height: 290px;
  padding: 1rem;
  border-radius: 22px;
  box-shadow: 0 2px 5px rgba(100, 98, 117, 0.11);

  margin-right: 3rem;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  box-sizing: border-box;

  &:hover {
    .card-img-main {
      opacity: 0;
    }

    .card-img-second {
      opacity: 1;
    }
    .fast-forward-wrapper {
      opacity: 0.95;
      cursor: pointer;
    }
  }

  .el-image__inner {
    width: 405px;
    height: 270px;
    border-radius: 1.8rem;
  }

  .card-img-main {
    opacity: 1;
    transition: all 0.3s ease-in-out;
  }

  .card-img-second {
    display: block;
    position: absolute;
    top: 1rem;
    left: 1rem;
    width: 405px;
    height: 270px;
    //padding: 1rem;
    //max-width: 100%;
    opacity: 0;
    transition: all 0.3s ease-in-out;
  }

  .el-dialog {
    border-radius: 1.8rem;
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    background-color: #ffffff;
    padding: 2.5rem 2rem 2.9rem 2rem;
    border-radius: 1.8rem;
  }
  .el-dialog__headerbtn {
    top: -2.5rem;
    right: -1rem;
    width: 3.2rem;
    height: 3.2rem;
    background: #ffffff;
    border-radius: 1.1rem;
    transform: translateX(100%);
  }

  .fast-forward-wrapper {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 1.6rem;
    padding-bottom: 1.3rem;
    font-family: 'Nunito-Regular', sans-serif;
    font-size: 1.4rem;
    background-color: #fff;
    color: #39373c;
    bottom: 1.5rem;
    left: 50%;
    transform: translateX(-50%);
    max-width: 38.5rem;
    width: 100%;
    border-radius: 1.4rem;
    opacity: 0;
    transition: all 0.3s ease-in-out;
    border: none;
    outline: none;

    span {
      margin-left: 1rem;
    }
  }
}
@media (max-width: 500px) {
  .apartment-img-main {
    width: 100%;
    height: 100%;
  }
  .sellers-dialog {
    .el-dialog__header.el-dialog__headerbtn {
      top: 0;
    }
  }
}
</style>
